import { useEffect, useMemo, useState } from "react";
import type { CharacterState, MediaRecord } from "../types/app";

interface Props {
  media?: MediaRecord;
  state: CharacterState;
  name: string;
}

export function CharacterStage({ media, state, name }: Props) {
  const [url, setUrl] = useState<string>("");
  useEffect(() => {
    if (!media) return undefined;
    const objectUrl = URL.createObjectURL(media.blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [media]);
  const isVideo = media?.type === "video";
  const initials = useMemo(() => name.slice(0, 2) || "AI", [name]);
  return (
    <section className={`character-stage ${state}`} aria-label={`${name}の表示`}>
      {url && media?.type === "image" ? <img src={url} alt={`${name}の画像`} /> : null}
      {url && isVideo ? <video src={url} muted playsInline loop={state === "speaking"} autoPlay={state === "speaking"} aria-label={`${name}の動画`} /> : null}
      {!url ? <div className="character-placeholder" aria-hidden="true">{initials}</div> : null}
      <div className="audio-glow" aria-hidden="true" />
      <div className="state-label">{state === "listening" ? "聞いています" : state === "speaking" ? "話しています" : "待機中"}</div>
    </section>
  );
}
